import React from "react";

const BusinessIcon = ({ fill = "#333333", ...delegated }) => {
  return (
    <svg
      width="40"
      height="34"
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path
        d="M11 4.35767V6.85767H21V4.35767C21 4.10767 20.75 3.85767 20.5 3.85767H11.5C11.1875 3.85767 11 4.10767 11 4.35767ZM8 6.85767V4.35767C8 2.48267 9.5625 0.857666 11.5 0.857666H20.5C22.375 0.857666 24 2.48267 24 4.35767V6.85767H28C30.1875 6.85767 32 8.67017 32 10.8577V12.9202C31.625 12.9202 31.3125 12.8577 31 12.8577C30.3125 12.8577 29.625 12.9202 29 13.0452V10.8577C29 10.3577 28.5 9.85767 28 9.85767H22.5H9.5H4C3.4375 9.85767 3 10.3577 3 10.8577V16.8577H12H22H22.5C21.125 18.5452 20.25 20.6077 20 22.8577H14C12.875 22.8577 12 21.9827 12 20.8577V19.8577H3V26.8577C3 27.4202 3.4375 27.8577 4 27.8577H20.75C21.125 28.9827 21.75 29.9827 22.5 30.8577H4C1.75 30.8577 0 29.1077 0 26.8577V18.3577V10.8577C0 8.67017 1.75 6.85767 4 6.85767H8ZM22 23.8577C22 20.6702 23.6875 17.7327 26.5 16.1077C29.25 14.4827 32.6875 14.4827 35.5 16.1077C38.25 17.7327 40 20.6702 40 23.8577C40 27.1077 38.25 30.0452 35.5 31.6702C32.6875 33.2952 29.25 33.2952 26.5 31.6702C23.6875 30.0452 22 27.1077 22 23.8577ZM31 18.8577C30.4375 18.8577 30 19.3577 30 19.8577V23.8577C30 24.4202 30.4375 24.8577 31 24.8577H34C34.5 24.8577 35 24.4202 35 23.8577C35 23.3577 34.5 22.8577 34 22.8577H32V19.8577C32 19.3577 31.5 18.8577 31 18.8577Z"
        fill={fill}
      />
    </svg>
  );
};

export { BusinessIcon };
